import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=518f5114&scoped=true&lang=pug"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"
import style0 from "./ResourceTable.vue?vue&type=style&index=0&id=518f5114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f5114",
  null
  
)

export default component.exports